import { Pallet } from 'interfaces';

export const getFreePalletAmount = (freePallets: Pallet[]) =>
   freePallets.reduce(
      (freePalletSum, currentFreePallet) => (freePalletSum += currentFreePallet.amount),
      0,
   );
